module.exports = __webpack_public_path__ + "img/teacat_img_shop_error.ef1cb507.png";